(() => {
  const FALLBACK_APPLIED_ATTR = 'data-fallback-applied';

  const applyFallbackToPicture = (img) => {
    if (!img || img.getAttribute(FALLBACK_APPLIED_ATTR) === 'true') return;

    const picture = img.closest('picture');
    if (!picture) return;

    picture.querySelectorAll('source[data-fallback-srcset]').forEach((source) => {
      const fallbackSrcset = source.getAttribute('data-fallback-srcset');
      if (fallbackSrcset) source.setAttribute('srcset', fallbackSrcset);
    });

    const fallbackImgSrcset = img.getAttribute('data-fallback-srcset');
    if (fallbackImgSrcset) {
      img.setAttribute('srcset', fallbackImgSrcset);

      const firstCandidate = fallbackImgSrcset.split(',')[0];
      if (firstCandidate) {
        const url = firstCandidate.trim().split(' ')[0];
        if (url) img.setAttribute('src', url);
      }
    }

    img.setAttribute(FALLBACK_APPLIED_ATTR, 'true');
  };

  document.addEventListener(
    'error',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLImageElement)) return;
      if (!target.hasAttribute('data-fallback-srcset')) return;
      applyFallbackToPicture(target);
    },
    true
  );
})();
